module.exports = __webpack_public_path__ + "static/media/image-card-5.a6c38fa4.png";